module.exports = __webpack_public_path__ + "img/user-tie-solid updated 2.40b0bf4f.svg";